import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;
export const payApi = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
